export enum LineType {
  line = 'line',
  gap = 'gap'
}
